import * as React from 'react';
export var CustomizerContext = React.createContext({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {}
    }
});
//# sourceMappingURL=CustomizerContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/node_modules/@uifabric/styling/node_modules/@uifabric/utilities/lib/customizations/CustomizerContext.js
// module id = 85
// module chunks = 0